export const formatToBrazilianCurrency = (value = 0, isCurrency = true) =>
  isCurrency
    ? value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : value.toLocaleString('pt-BR', {
        maximumFractionDigits: 2,
      });
